/* eslint-disable import/first */
import React, { useState, useEffect } from 'react';

/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
const { selectDesktop } = Slices.appSlice;
import TrackOrderComponent from './TrackOrderComponent';
import Paper from '@material-ui/core/Paper';
import Header from '../../components/Header';
import LanguageButton from '../../components/LanguageButton';
import { FormattedMessage } from 'react-intl';
import css from './TrackOrderComponent.module.scss';
// import NotLoggedIn from './NotLoggedIn';
import NotLogged from '../../components/NotLogged';
import notLoggedInImg from './images/notlogin.svg';
import Loader from '../../components/Loader';

const { getCurrentOrders } = Slices.orderSlice;

const TrackOrder = () => {
  const dispatch = useDispatch();
  const isDesktop = useSelector(selectDesktop);
  const auth = useSelector((state) => state.auth);
  const [pageLoader, setPageLoader] = useState(false);

  useEffect(() => {
    setPageLoader(true);
    dispatch(getCurrentOrders({ page: 1 })).then((res) => {
      setPageLoader(false);
    });
  }, []);

  return (
    <div>
      {!isDesktop && (
        <Header
          title={<FormattedMessage id="navigation_trackOrder" defaultMessage="Track Order" />}
          actionButtons={[<LanguageButton />]}
        />
      )}

      <Paper square className={css.paper}>
        {!auth.isLoggedIn ? (
          <div className={css.notLoggedIn}>
            <NotLogged
              topbar={false}
              url='/track-order'
              heading={
                <FormattedMessage id="no_orders_available" defaultMessage="No Orders Available" />
              }
              subHeading={
                <FormattedMessage
                  id="login_to_view"
                  defaultMessage="Please login to view the orders"
                />
              }
              img={notLoggedInImg}
            />
          </div>
        ) : (
          <>
            {pageLoader && <Loader />}
            <TrackOrderComponent />
          </>
        )}
      </Paper>
    </div>
  );
};

export default TrackOrder;
